import axios from "axios";
const { API_BACKEND_HOST } = process.env;

const api = axios.create({
  baseURL: `${API_BACKEND_HOST}`,
});

interface ICreateParams {
  name: string;
  businessUnitId: string;
}

interface IUpdateParams {
  id: string;
  name: string;
  businessUnitId: string;
}
interface IGetCommitteePackageResponse {
  name: string;
  businessUnitId: string;
  businessUnitName: string;
  active: boolean;
  admin: boolean;
  committees: {
    id: string;
    name: string;
  }[];
  groups: {
    id: string;
    name: string;
    groupAdminLevel: number;
  }[]
}

export interface ILog {
  responsibleUserId: string,
  responsibleUserName: string,
  actionType: string,
  entity: string,
  actionName: string,
  actionDescription: string,
  oldVersion: string,
  currentVersion: string,
  createdDate: string,
  changeDate: string
}

interface IGetAllLogs {
  actionsHistory: ILog[];
  count: number;
  currentPage: number;
  pageSize: number;
  totalPages:number;
}

interface IGetOptions {
  id: number;
  name: string;
}

interface IPagination {
  page: number;
  pageSize: number
}

interface IFilters {
  actionType?: string; 
  functionality?: string;
  responsible?: string;
  actionDescription?: string;
  initialDate?: Date;
  finalDate?: Date;
}

export const getAllLogs = async (pagination: IPagination, filters?: IFilters) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get<IGetAllLogs>(
    `${API_BACKEND_HOST}${languageId}/v1/Audit`,
    {
      params: {
        ...pagination,
        ...(filters?.actionType && {actionType: filters.actionType}),
        ...(filters?.responsible && {user: filters.responsible}),
        ...(filters?.functionality && {entity: filters.functionality}),
        ...(filters?.initialDate && {initialDate: filters.initialDate}),
        ...(filters?.finalDate && {finalDate: filters.finalDate}),
        ...(filters?.actionDescription && {actionDescription: filters.actionDescription}),
      }
    }
  );

  return data;
};

export const getAllActionTypeOptions = async () => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get<IGetOptions[]>(
    `${API_BACKEND_HOST}${languageId}/v1/Audit/ActionTypes`,
  );

  return data;
};

export const getAllFunctionalityOptions = async () => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get<IGetOptions[]>(
    `${API_BACKEND_HOST}${languageId}/v1/Audit/Entities`,
  );

  return data;
};
